import { useDispatch, useSelector } from "react-redux"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import ExchangeAndMobility from "../components/internationalOffice/exchangeandMobility"
import InternationalCooperation from "../components/internationalOffice/internationalCooperation"
import Welcome from "../components/internationalOffice/welcome"
import { useEffect } from "react"
import { fetchInternationalOfficeData } from "../redux/slice/internationalOfficePage"
import { retrunAssets } from './../utils/getAssets';
import TabsPage from "./TabsPage"
import WelcomeIc from "../components/internationalOffice/welcomeIc"
import ICSection from "../components/internationalOffice/iCSection"
import ISSSection from "../components/internationalOffice/iSSSection"

const InternationalOffices = () => {

    const state = useSelector(state => state.internationalOffice)
    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data == null) {
            dispatch(fetchInternationalOfficeData("international-office"))
        }

    }, [state, dispatch])

    const internationalOffice = state?.data?.properties


    const text = internationalOffice?.pagetitle
    const bg = internationalOffice?.backgroundImage != null ? retrunAssets(internationalOffice?.backgroundImage[0]?.url) : ""

    const tabs = [
        {
            header: "International Office",
            content: <Welcome internationalOffice={internationalOffice} />,
        },
        {
            header: "International Student Services (ISS)",
            content: <ISSSection internationalOffice={internationalOffice} />,
        },
        {
            header: "International Cooperation IC",
            content: <ICSection internationalOffice={internationalOffice} />,
        }
    ]






    return (
        // <AnimatedPage>
        //     {/* <ScrollToTop/> */}
        //     <Banner text={text} bg={bg} />
        //     <Welcome internationalOffice={internationalOffice}/>
        //     <ExchangeAndMobility internationalOffice={internationalOffice}/>
        //     <InternationalCooperation internationalOffice={internationalOffice}/>
        // </AnimatedPage>
        <TabsPage title={text} bg={bg} tabs={tabs} />
    )
}

export default InternationalOffices